import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { auth0Locales } from '../../i18n';
import { useLanguage } from '../../i18n/LanguageProvider';
import { TokenService } from './TokenService';

export const TokenSetter = () => {
  const {
    isLoading,
    isAuthenticated,
    getAccessTokenSilently,
    loginWithRedirect,
  } = useAuth0();
  const { language } = useLanguage();

  useEffect(() => {
    const setToken = async () => {
      if (isLoading || !isAuthenticated) return;

      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          },
        });
        TokenService.setToken(token);
      } catch (error) {
        console.error('Token error:', error);
        if (
          error &&
          typeof error === 'object' &&
          'message' in error &&
          (error as Error).message === 'Login required'
        ) {
          try {
            await loginWithRedirect({
              authorizationParams: { ui_locales: auth0Locales[language] },
            });
          } catch (redirectError) {
            console.error('Redirect error:', redirectError);
          }
        }
      }
    };
    setToken();
  }, [
    isLoading,
    isAuthenticated,
    getAccessTokenSilently,
    loginWithRedirect,
    language,
  ]);

  return null;
};
